export default __webpack_public_path__ + "static/media/Front_Wall_AO.0e6b7b25.jpg";